(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mini-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    setupMiniCart();
    setupMiniCartRemoveButtons();
    setupCartUpdateListener();
  });
  
  // Écouter les mises à jour du panier principal
  function setupCartUpdateListener() {
    document.addEventListener('cart:updated', function(event) {
      const { cart, updatedItemKey, newQuantity } = event.detail;
      
      // Mettre à jour le compteur du panier
      updateCartCount(cart.item_count);
      
      // Mettre à jour le sous-total
      const subtotalElement = document.querySelector('.mini-cart__subtotal span:last-child');
      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cart.total_price);
      }
      
      // Si la quantité est 0, supprimer l'élément du mini-panier
      if (newQuantity === 0) {
        const miniCartItem = document.querySelector(`.mini-cart-item[data-key="${updatedItemKey}"]`);
        if (miniCartItem) {
          // Ajouter une classe pour indiquer que l'élément est en cours de suppression
          miniCartItem.classList.add('removing');
          
          // Supprimer l'élément du DOM avec une animation
          miniCartItem.style.height = miniCartItem.offsetHeight + 'px';
          setTimeout(() => {
            miniCartItem.style.height = '0';
            miniCartItem.style.opacity = '0';
            miniCartItem.style.margin = '0';
            miniCartItem.style.padding = '0';
            
            setTimeout(() => {
              miniCartItem.remove();
              
              // Si le panier est vide, afficher le message "panier vide"
              if (cart.item_count === 0) {
                const itemsContainer = document.querySelector('.mini-cart__items');
                const footerContainer = document.querySelector('.mini-cart__footer');
                
                if (itemsContainer) {
                  itemsContainer.remove();
                }
                
                if (footerContainer) {
                  footerContainer.remove();
                }
                
                const contentContainer = document.querySelector('.mini-cart__content');
                if (contentContainer) {
                  const emptyMessage = document.createElement('p');
                  emptyMessage.className = 'mini-cart__empty-message';
                  // Utiliser la traduction du mini-cart vide
                  const emptyCartText = "{{ 'cart.mini_cart.empty_cart' | t }}";
                  emptyMessage.textContent = emptyCartText;
                  contentContainer.appendChild(emptyMessage);
                }
              }
            }, 300);
          }, 10);
        }
      } else {
        // Mettre à jour la quantité et le prix de l'élément dans le mini-panier
        const miniCartItem = document.querySelector(`.mini-cart-item[data-key="${updatedItemKey}"]`);
        if (miniCartItem) {
          // Trouver l'élément de quantité et le mettre à jour
          const quantityElement = miniCartItem.querySelector('.mini-cart-item__quantity-value');
          if (quantityElement) {
            quantityElement.textContent = newQuantity;
          }
          
          // Trouver l'élément de prix et le mettre à jour
          const priceElement = miniCartItem.querySelector('.mini-cart-item__price');
          if (priceElement) {
            // Trouver l'article correspondant dans le panier pour obtenir le prix mis à jour
            const cartItem = cart.items.find(item => item.key === updatedItemKey);
            if (cartItem) {
              priceElement.textContent = formatMoney(cartItem.final_line_price);
            }
          }
        }
      }
    });
  }
  
  function setupMiniCart() {
    const miniCart = document.querySelector('#mini-cart');
    const cartLink = document.querySelector('.cart-link');
    const closeButton = document.querySelector('.mini-cart__close-button');
    
    if (!miniCart || !cartLink || !closeButton) return;
    
    // Ouvrir le mini-panier au clic sur l'icône du panier
     cartLink.addEventListener('click', function(event) {
       event.preventDefault();
       const isActive = miniCart.classList.toggle('is-active');
       miniCart.setAttribute('aria-hidden', !isActive);
     });
     
     // Fermer le mini-panier au clic sur le bouton de fermeture
     closeButton.addEventListener('click', function() {
       miniCart.classList.remove('is-active');
       miniCart.setAttribute('aria-hidden', 'true');
     });
     
     // Fermer le mini-panier au clic en dehors
     document.addEventListener('click', function(event) {
       if (!miniCart.contains(event.target) && !cartLink.contains(event.target)) {
         miniCart.classList.remove('is-active');
         miniCart.setAttribute('aria-hidden', 'true');
       }
     });
     
 
  }

  function setupMiniCartRemoveButtons() {
    const miniCart = document.querySelector('#mini-cart');
    if (!miniCart) return;

    // Délégation d'événements pour les boutons de suppression
    miniCart.addEventListener('click', function(event) {
      const removeButton = event.target.closest('.mini-cart-item__remove');
      if (!removeButton) return;

      event.preventDefault();
      const itemKey = removeButton.dataset.itemKey;
      const line = removeButton.dataset.line;
      const miniCartItem = removeButton.closest('.mini-cart-item');
      
      if (!itemKey || !line || !miniCartItem) return;
      
      // Ajouter une classe pour indiquer que l'élément est en cours de suppression
      miniCartItem.classList.add('removing');
      
      // Appel AJAX pour supprimer l'article
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      })
      .then(response => response.json())
      .then(cart => {
        // Mettre à jour le compteur du panier
        updateCartCount(cart.item_count);
        
        // Mettre à jour le sous-total
        const subtotalElement = document.querySelector('.mini-cart__subtotal span:last-child');
        if (subtotalElement) {
          subtotalElement.textContent = formatMoney(cart.total_price);
        }
        
        // Supprimer l'élément du DOM avec une animation
        miniCartItem.style.height = miniCartItem.offsetHeight + 'px';
        setTimeout(() => {
          miniCartItem.style.height = '0';
          miniCartItem.style.opacity = '0';
          miniCartItem.style.margin = '0';
          miniCartItem.style.padding = '0';
          
          setTimeout(() => {
            miniCartItem.remove();
            
            // Si le panier est vide, afficher le message "panier vide"
            if (cart.item_count === 0) {
              const itemsContainer = document.querySelector('.mini-cart__items');
              const footerContainer = document.querySelector('.mini-cart__footer');
              
              if (itemsContainer) {
                itemsContainer.remove();
              }
              
              if (footerContainer) {
                footerContainer.remove();
              }
              
              const contentContainer = document.querySelector('.mini-cart__content');
              if (contentContainer) {
                const emptyMessage = document.createElement('p');
                emptyMessage.className = 'mini-cart__empty-message';
                // Utiliser la traduction du mini-cart vide
                const emptyCartText = "{{ 'cart.mini_cart.empty_cart' | t }}";
                emptyMessage.textContent = emptyCartText;
                contentContainer.appendChild(emptyMessage);
              }
            }
          }, 300);
        }, 10);
      })
      .catch(error => {
        console.error('Error removing item from cart:', error);
        miniCartItem.classList.remove('removing');
      });
    });
  }
  
  function updateCartCount(count) {
    // Récupérer le nombre réel de produits (sans compter les composants de bundle)
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Filtrer les articles qui sont des composants de bundle
        // Les composants de bundle ont généralement une propriété _bundleId ou _component
        const realItemCount = cart.items.filter(item => {
          // Vérifier si l'article a des propriétés qui indiquent qu'il est un composant
          const isComponent = item.properties && (
            item.properties._bundleId || 
            item.properties._component || 
            item.properties._bundleComponent ||
            (item.properties._bundleParentId && item.properties._bundleParentId !== '')
          );
          return !isComponent;
        }).length;
        
        // Mettre à jour les compteurs avec le nombre réel de produits
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = realItemCount;
          element.dataset.cartCount = realItemCount;
        });
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du panier:', error);
        // En cas d'erreur, utiliser le compte standard
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = count;
          element.dataset.cartCount = count;
        });
      });
  }
  
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = parseInt(cents || 0, 10);
    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
    
    return formatter.format(value / 100);
  }
  } catch(e) { console.error(e); }
})();

})();
